import { render, staticRenderFns } from "./bridger-blox.vue?vue&type=template&id=855f819e&scoped=true"
import script from "./bridger-blox.vue?vue&type=script&lang=js"
export * from "./bridger-blox.vue?vue&type=script&lang=js"
import style0 from "./bridger-blox.vue?vue&type=style&index=0&id=855f819e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855f819e",
  null
  
)

export default component.exports